import { Schema as S } from "effect";

export const FindScheduleRequestSchema = S.Struct({
  _id: S.String,
});

export type FindScheduleRequest = S.Schema.Type<typeof FindScheduleRequestSchema>;
